export default {
	label: 'Audit',
	activeAudit: 'Active audit',
	name: 'Audit name',
	finishedAudits: 'Finished audits',
	finishDialog: {
		title: 'Confirm Finalization',
		body: 'Finished audits cannot be edited. Are you sure you want to finalize changes to "{auditName}"?',
	},
	noActiveAudits: {
		header: 'No active audits',
		body: 'User has no permission to start audits or add audit comments.',
	},
	foreignInternalComments: 'Foreign internal auditor comments',
	comment: 'Auditor comment | Auditor comments',
	internalComments: 'Internal auditor comments',
	addComment: 'Add audit comment',
	noComments: 'No comments',
	type: 'Audit type',
	noAudit: 'Nothing',
	basicAudit: 'Audit',
	basicAbbr: 'A',
	foreignInternalAudit: 'Foreign internal audit',
	foreignInternalAbbr: 'FIA',
	internalAudit: 'Internal audit',
	privateInternalAbbr: 'IA',
	publicInternalAbbr: 'PIA',
	startNew: 'Start new audit',
	new: 'New audit',
	confirmNew: 'Current audit will be completed. Are you sure?',
	created: 'New audit has been created',
	addUserReply: 'Add user reply',
	completed: 'Audit completed',
	basicAuditor: 'Auditor',
	internalAuditor: 'Internal auditor',
	published: 'Audit published',
	ok: 'Ok',
	remark: 'Remark',
	defect: 'Defect',
	checks: 'Audit checks',
	noKind: 'Comment',
	addThisToAudit: 'Add to audit selection',
	inAudit: 'In audit selection',
	emptied: 'Audit selection emptied',
	empty: 'Empty selection',
	addToAudit: 'Add to audit selection',
	removeFromAudit: 'Remove from audit selection',
	cantAdd: 'Select institution before creating new audit',
}
